import { XMarkIcon } from "@heroicons/react/24/outline";

interface ChipRemoveButtonProps {
    label: string;
    onPress(): void;
}

export const ChipRemoveButton = ({ label, onPress }: ChipRemoveButtonProps) => (
    <button
        type="button"
        onClick={onPress}
        className="active-filter-chip__remove"
        aria-label={`Remove ${label}`}
    >
        <XMarkIcon className="w-3.5 h-3.5" />
    </button>
);
